/* eslint-disable no-nested-ternary */
import React, { forwardRef, useState } from 'react';
import styled from 'styled-components';
import { Link, Tooltip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import ZoomOutMapIcon from '@material-ui/icons/ZoomOutMap';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Checkmark, Printer } from '@mummssoftware/icons';
import { ActionIcon } from '../ActionIcon';
import messages from './messages';
const WidgetHeaderWrapper = styled.div.withConfig({
  displayName: "WidgetHeader__WidgetHeaderWrapper",
  componentId: "p6plh2-0"
})(["min-height:", ";background-color:", ";", " letter-spacing:0.0625em;font-weight:normal;font-family:'Muli',sans-serif;border-spacing:0px;display:flex;align-items:center;justify-content:space-between;padding-left:5px;margin-bottom:2px;color:", ";"], props => `${props.theme.props.dashboard.widgetHeaderHeight}px`, props => props.theme.palette.background.paper, props => props.isForm ? `;` : `font-size: 18px;`, props => props.theme.palette.text.primary);
const WidgetTitle = styled.div.withConfig({
  displayName: "WidgetHeader__WidgetTitle",
  componentId: "p6plh2-1"
})(["padding-left:0.5rem;padding-right:0.5rem;", " ", ""], props => props.isForm ? `;` : `text-transform: uppercase;`, props => props.isForm ? `height: 35px;
      font-size: min(1.5vw,18px); 
      display: flex;
      align-items: center;` : `;`);
const WidgetButtonWrapper = styled.div.withConfig({
  displayName: "WidgetHeader__WidgetButtonWrapper",
  componentId: "p6plh2-2"
})(["display:flex;justify-content:flex-end;"]);
const WidgetRightWrapper = styled.div.withConfig({
  displayName: "WidgetHeader__WidgetRightWrapper",
  componentId: "p6plh2-3"
})(["display:flex;justify-content:flex-start;align-items:center;"]);
const WidgetLeftWrapper = styled.div.withConfig({
  displayName: "WidgetHeader__WidgetLeftWrapper",
  componentId: "p6plh2-4"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;"]);
const ToggleActionButton = withStyles({
  closeIcon: {
    height: '15px'
  },
  closeButton: {
    margin: '0 3px 0 0'
  }
})(injectIntl(({
  showClose,
  toggleWidget,
  link,
  target,
  disabled,
  intl: {
    formatMessage
  },
  classes
}) => link ? /*#__PURE__*/React.createElement(Link, {
  color: "textPrimary",
  style: {
    textDecoration: 'none'
  },
  href: link,
  target: target
}, /*#__PURE__*/React.createElement(ActionIcon, {
  title: showClose ? formatMessage(messages.close) : formatMessage(messages.openOutside),
  Icon: showClose ? Checkmark : OpenInNewIcon,
  onClick: toggleWidget,
  className: classes.closeButton,
  iconProps: {
    className: classes.closeIcon
  }
}), ' ') : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ActionIcon, {
  title: showClose ? formatMessage(messages.close) : formatMessage(messages.open),
  Icon: showClose ? Checkmark : ZoomOutMapIcon,
  onClick: toggleWidget,
  className: classes.closeButton,
  iconProps: {
    className: classes.closeIcon
  },
  disabled: disabled
}))));

const ToggleWidgetButton = ({
  showClose,
  toggleWidget,
  onlyCloseWidget,
  link,
  disabled,
  target
}) => onlyCloseWidget && !showClose ? null : /*#__PURE__*/React.createElement(ToggleActionButton, {
  toggleWidget: toggleWidget,
  showClose: showClose,
  onlyCloseWidget: onlyCloseWidget,
  link: link,
  target: target,
  disabled: disabled
});

const PrintWidgetButton = withStyles({
  printIcon: {
    height: '15px'
  },
  printButton: {
    margin: '0 3px 0 0'
  }
})(injectIntl(({
  showPrint,
  printWidget,
  intl: {
    formatMessage
  },
  classes
}) => /*#__PURE__*/React.createElement(ActionIcon, {
  title: formatMessage(messages.print),
  Icon: Printer,
  onClick: printWidget,
  className: classes.printButton,
  iconProps: {
    className: classes.printIcon
  },
  visible: showPrint
})));
export const WidgetHeader = /*#__PURE__*/forwardRef(({
  onClick,
  onPrint,
  showPrint,
  appTitle,
  smallWidget,
  onlyCloseWidget,
  noIcon,
  link,
  target,
  versionInfo,
  position,
  disabled,
  isForm,
  children
}, ref) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleTitleTooltipClose = () => {
    setTooltipOpen(false);
  };

  const handleTitleTooltipOpen = e => {
    if (e.altKey) {
      setTooltipOpen(true);
    }
  };

  return /*#__PURE__*/React.createElement(WidgetHeaderWrapper, {
    ref: ref,
    className: "widget-header",
    isForm: isForm
  }, position === 'left' ? /*#__PURE__*/React.createElement(WidgetLeftWrapper, {
    className: "widget-header-left"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "bottom-start",
    title: versionInfo || 'v',
    "aria-label": "about",
    open: tooltipOpen,
    onClose: handleTitleTooltipClose
  }, /*#__PURE__*/React.createElement(WidgetTitle, {
    onClick: handleTitleTooltipOpen,
    isForm: isForm
  }, appTitle)), children) : /*#__PURE__*/React.createElement(WidgetRightWrapper, {
    className: "widget-header-right"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "bottom-start",
    title: versionInfo || 'v',
    "aria-label": "about",
    open: tooltipOpen,
    onClose: handleTitleTooltipClose
  }, /*#__PURE__*/React.createElement(WidgetTitle, {
    onClick: handleTitleTooltipOpen,
    isForm: isForm
  }, appTitle)), children), /*#__PURE__*/React.createElement(WidgetButtonWrapper, {
    className: "widget-button"
  }, showPrint && /*#__PURE__*/React.createElement(PrintWidgetButton, {
    printWidget: onPrint
  }), !noIcon && /*#__PURE__*/React.createElement(ToggleWidgetButton, {
    toggleWidget: onClick,
    showClose: !smallWidget,
    onlyCloseWidget: onlyCloseWidget,
    link: link,
    target: target,
    disabled: disabled
  })));
});
export default WidgetHeader;